export enum ContactIdentifierType {
  CUSTOMER = "customer",
  SUPPLIER = "supplier",
  CUSTOMER_SUPPLIER = "customer_supplier",
}
